function renderDeep(val: any, ctx: Record<string, any>): any {
  if (typeof val === "string") return renderTpl(val, ctx);
  if (Array.isArray(val)) return val.map((v) => renderDeep(v, ctx));
  if (val && typeof val === "object") {
    const out: any = {};
    for (const k of Object.keys(val)) out[k] = renderDeep(val[k], ctx);
    return out;
  }
  return val;
}

function renderTpl(tpl: string, ctx: Record<string, any>): string {
  if (!tpl) return "";
  return tpl.replace(/{{\s*([.\w-]+)\s*}}/g, (_, path) => {
    const val = path.split(".").reduce((o: any, k: string) => (o && o[k] != null ? o[k] : ""), ctx);
    return (val ?? "").toString();
  });
}

export function renderCtx(ctx: Record<string, any>, toRender: any) {
  // Accept arrays or single values/objects
  if (Array.isArray(toRender)) {
    return toRender.map((q) => renderDeep(q, ctx));
  }
  return renderDeep(toRender, ctx);
}
